import React from 'react';

interface Props {
  children: Element[];
  styles: Record<string, string>;
}

const ComponentHeader = ({ children, styles = {} }: Props) => (
  <div
    style={{
      ...styles,
      borderBottom: 'solid 1px #DDDDDD',
      display: 'flex',
      justifyContent: 'center',
      padding: '40px 0 40px 0',
    }}
  >
    {children}
  </div>
);

export default ComponentHeader;
